<template>
	<div class="faq-wrapper">
		<div class="faq-title">
			<h4 class="heading-normal">{{ $t('wallet.faq') }}
				<a :href="faqAll.faqAll.url" target="_blank" class="view-all text-uppercase">
					<strong>
						{{ $t('wallet.view-all-faq') }}
					</strong>
					<svgIcon iconHolderClass="icon-faq" iconId="icon-page-right"/>
				</a>
			</h4>

			<div class="clearfix"></div>
		</div>

		<ul class="faq-list list-unstyled">
			<a
				v-for="faq in faqLists"
				:href="faq.url"
				target="_blank"
				rel="external"
				class="faq-link">
				<li>
					{{ $t(`wallet.${faq.name}`) }}
					<svgIcon iconHolderClass="icon-faq" iconId="icon-page-right"/>
				</li>
			</a>
		</ul>
	</div>
</template>

<script>
import panel from '@arena/toolkit/src/components/common/panel';
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import faqList from '../../config/add-balance-faq-list';
import faqAll from '../../config/add-balance-faq-all';

export default {
	name: 'faqWidget',
	components: {
		panel,
		svgIcon
	},
	data() {
		return {
			faqLists: faqList[environment.region],
			faqAll: faqAll[environment.region],
		};
	},
};
</script>

<style lang="less" scoped>
	.faq-list {
		a {
			color: #8c8c8c;
			font-size: 16px;
			li {
				padding-top: 28px;
				padding-bottom: 28px;
				border-bottom: 1px solid #383838;
				transition: .3s ease;

				.icon-faq {
					float: right;
					width: 10px;
					height: 10px;
					transition: .3s ease;
					opacity: .5;
					margin: 5px 0 0 5px;
				}
				&:hover {
					color: #d9d9d9;
					.icon-faq {
						opacity: .8;
					}
				}
			}
		}
	}
	.faq-title {
		h4 {
			color: #d9d9d9;
		}
		.heading-normal{
			margin-top: 60px;
		}
		border-bottom: 2px solid #999999;
		padding-bottom: 10px;
		.view-all {
			font-size: 12px;
			display: inline-block;
			float: right;
			position: relative;
			margin-top: 10px;
			color: #8c8c8c;
			.icon-faq {
				width: 10px;
				height: 10px;
				transition: .3s ease;
				opacity: .5;
				margin-left: 5px;
			}
			&:hover {
				color: #d9d9d9;
				.icon-faq {
					opacity: 1;
				}
			}
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/common/faq-widget.vue